import { DEMO_CONTENTS, DEMO_PRODUCTS } from './contentMock';

const physicians = [
  { physician_id: 'demo-physician-01', physician_name: '陈晓明', sex: '男', department_name: '精神科', professional_title: '主任医师', institution_name: '上海市精神卫生中心', physician_segment: 'A', physician_class: '核心', is_wechat: 1, is_favorite: 1 },
  { physician_id: 'demo-physician-02', physician_name: '李婉清', sex: '女', department_name: '神经内科', professional_title: '副主任医师', institution_name: '北京协和医院', physician_segment: 'B', physician_class: '潜力', is_wechat: 1, is_favorite: 0 },
  { physician_id: 'demo-physician-03', physician_name: '王志远', sex: '男', department_name: '老年医学科', professional_title: '主任医师', institution_name: '华山医院', physician_segment: 'A', physician_class: '核心', is_wechat: 1, is_favorite: 1 },
  { physician_id: 'demo-physician-04', physician_name: '赵一鸣', sex: '男', department_name: '神经内科', professional_title: '主治医师', institution_name: '中山医院', physician_segment: 'C', physician_class: '成长', is_wechat: 0, is_favorite: 0 },
  { physician_id: 'demo-physician-05', physician_name: '周静', sex: '女', department_name: '精神科', professional_title: '副主任医师', institution_name: '南京脑科医院', physician_segment: 'B', physician_class: '潜力', is_wechat: 1, is_favorite: 0 },
  { physician_id: 'demo-physician-06', physician_name: '刘思远', sex: '男', department_name: '疼痛科', professional_title: '主任医师', institution_name: '浙江大学医学院附属第一医院', physician_segment: 'A', physician_class: '核心', is_wechat: 1, is_favorite: 1 },
  { physician_id: 'demo-physician-07', physician_name: '孙嘉宁', sex: '女', department_name: '神经内科', professional_title: '主治医师', institution_name: '复旦大学附属华山医院', physician_segment: 'B', physician_class: '成长', is_wechat: 1, is_favorite: 0 },
  { physician_id: 'demo-physician-08', physician_name: '黄俊杰', sex: '男', department_name: '老年医学科', professional_title: '副主任医师', institution_name: '瑞金医院', physician_segment: 'C', physician_class: '潜力', is_wechat: 0, is_favorite: 0 },
  { physician_id: 'demo-physician-09', physician_name: '吴佳怡', sex: '女', department_name: '精神科', professional_title: '主任医师', institution_name: '广州医科大学附属脑科医院', physician_segment: 'A', physician_class: '核心', is_wechat: 1, is_favorite: 1 },
];

function contentById(contentId) {
  return DEMO_CONTENTS.find(content => content.content_id === contentId) || DEMO_CONTENTS[0];
}

function productByPathology(pathologyId) {
  return DEMO_PRODUCTS.find(product => product.pathology_id === pathologyId) || DEMO_PRODUCTS[0];
}

function productForContent(content) {
  const relation = content.content__content_products && content.content__content_products[0];
  return relation ? relation.product : DEMO_PRODUCTS[0];
}

const campaignEvents = [
  {
    campaign_event_id: 'demo-event-mdd-content',
    campaign_event_name: '抑郁症患者功能恢复内容推送',
    event_type: 'content',
    content_id: 'demo-med-mdd-frontier',
    product_id: 'Brintellix_000001',
    product_name: 'Brintellix',
    event_start_date: '2026-06-01',
    event_end_date: '2026-07-15',
    target_physician_segment: '精神科重点医生',
    target_physician_class: 'A/B 级客户',
    prior_physician_segment: '近 30 天高互动医生',
  },
  {
    campaign_event_id: 'demo-event-pd-content',
    campaign_event_name: '帕金森病长期管理内容推送',
    event_type: 'content',
    content_id: 'demo-med-pd-frontier',
    product_id: 'Azilect_000001',
    product_name: 'Azilect',
    event_start_date: '2026-06-05',
    event_end_date: '2026-07-20',
    target_physician_segment: '神经内科重点医生',
    target_physician_class: '核心客户',
    prior_physician_segment: '近期拜访后待跟进',
  },
  {
    campaign_event_id: 'demo-event-ad-content',
    campaign_event_name: '认知障碍早筛路径内容推送',
    event_type: 'content',
    content_id: 'demo-med-ad-frontier',
    product_id: 'Ebixa_000001',
    product_name: 'Ebixa',
    event_start_date: '2026-06-08',
    event_end_date: '2026-07-22',
    target_physician_segment: '记忆门诊与老年科医生',
    target_physician_class: '潜力客户',
    prior_physician_segment: '未打开同类内容医生',
  },
  {
    campaign_event_id: 'demo-event-mdd-segment',
    campaign_event_name: 'MDD 患者管理分型补充',
    event_type: 'segment',
    content_id: 'demo-brand-mdd',
    product_id: 'Brintellix_000001',
    product_name: 'Brintellix',
    event_start_date: '2026-06-10',
    event_end_date: '2026-07-31',
    target_physician_segment: '需补充患者画像医生',
    target_physician_class: 'A/B 级客户',
    prior_physician_segment: '高潜医生',
  },
  {
    campaign_event_id: 'demo-event-followup-survey',
    campaign_event_name: '复诊沟通习惯小问卷',
    event_type: 'survey',
    questionnaire_id: 'demo-questionnaire-followup',
    content_id: 'demo-tool-checklist',
    product_id: 'Brintellix_000001',
    product_name: 'Brintellix',
    event_start_date: '2026-06-12',
    event_end_date: '2026-07-25',
    target_physician_segment: '近期活跃医生',
    target_physician_class: '目标客户',
    prior_physician_segment: '内容打开率较高医生',
  },
  {
    campaign_event_id: 'demo-event-migraine-content',
    campaign_event_name: '偏头痛规范化管理内容推送',
    event_type: 'content',
    content_id: 'demo-med-migraine-frontier',
    product_id: 'Vyepti_000001',
    product_name: 'Vyepti',
    event_start_date: '2026-06-15',
    event_end_date: '2026-07-28',
    target_physician_segment: '头痛门诊医生',
    target_physician_class: '潜力客户',
    prior_physician_segment: '患者教育需求较高医生',
  },
];

function makeTask(event, physician, index, status) {
  const content = contentById(event.content_id);
  const product = DEMO_PRODUCTS.find(item => item.product_id === event.product_id) || productForContent(content);
  const executionType = status || null;
  return {
    campaign_event_execution_id: executionType ? `demo-exec-${event.campaign_event_id}-${physician.physician_id}` : '',
    campaign_event_id: event.campaign_event_id,
    campaign_event_name: event.campaign_event_name,
    event_type: event.event_type,
    event_start_date: event.event_start_date,
    event_end_date: event.event_end_date,
    content_id: event.content_id,
    content_name: content.content_name,
    questionnaire_id: event.questionnaire_id || '',
    product_id: product.product_id,
    product_name: product.product_name,
    execution_type: executionType,
    is_optional: index % 3 !== 0,
    priority: index % 4 === 0 ? 1 : 0,
    ...physician,
  };
}

let taskRows = campaignEvents.flatMap((event, eventIndex) => {
  const start = eventIndex % 3;
  return physicians.slice(start, start + 6).map((physician, index) => {
    let status = null;
    if (index < 3 || (index === 3 && eventIndex < 4)) status = 'accept';
    if (index === 5 && eventIndex === 4) status = 'ignore';
    return makeTask(event, physician, index, status);
  });
});

function getFilteredTasks(productId, campaignEventId, isExecuted, executionType, physicianId) {
  return taskRows
    .filter(task => !physicianId || task.physician_id === physicianId)
    .filter(task => !productId || task.product_id === productId)
    .filter(task => !campaignEventId || String(task.campaign_event_id) === String(campaignEventId))
    .filter(task => {
      if (isExecuted === true || isExecuted === 'true') {
        return task.execution_type !== null && (!executionType || task.execution_type === executionType);
      }
      if (isExecuted === false || isExecuted === 'false') {
        return task.execution_type === null;
      }
      return true;
    });
}

function paginate(rows, pageNum, pageSize) {
  const size = Number(pageSize || 20);
  const page = Number(pageNum || 1);
  const start = (page - 1) * size;
  return rows.slice(start, start + size);
}

function buildEventStat(event) {
  const content = contentById(event.content_id);
  const rows = taskRows.filter(task => task.campaign_event_id === event.campaign_event_id);
  const unexecutedRows = rows.filter(task => task.execution_type === null);
  const acceptRows = rows.filter(task => task.execution_type === 'accept');
  const ignoreRows = rows.filter(task => task.execution_type === 'ignore');
  const topTasks = unexecutedRows.slice(0, 3);
  return {
    ...event,
    total_task_count: rows.length,
    content_name: content.content_name,
    unexecuted_task_count: unexecutedRows.length,
    accept_task_count: acceptRows.length,
    ignore_task_count: ignoreRows.length,
    top_tasks: topTasks,
    top_tasks_json: JSON.stringify(topTasks),
  };
}

export function getDemoTaskCount(userId, productId, roleId) {
  const rows = getFilteredTasks(productId, '', false, '', '');
  return Promise.resolve({ data: rows, data_count: rows.length });
}

export function getDemoTasks(userId, productId, campaignEventId, isExecuted, executionType, pageNum, pageSize, roleId) {
  const rows = getFilteredTasks(productId, campaignEventId, isExecuted, executionType, '');
  return Promise.resolve({
    data: paginate(rows, pageNum, pageSize),
    data_count: rows.length,
  });
}

export function getDemoCampaignEvents(userId, productId, roleId) {
  const events = campaignEvents
    .filter(event => !productId || event.product_id === productId)
    .map(buildEventStat)
    .sort((a, b) => new Date(b.event_start_date).getTime() - new Date(a.event_start_date).getTime());
  return Promise.resolve({ data: events, data_count: events.length });
}

export function getDemoMyCampaignEventStat() {
  const events = campaignEvents.map(buildEventStat);
  const totalTaskCount = taskRows.length;
  const acceptTaskCount = taskRows.filter(task => task.execution_type === 'accept').length;
  const ignoreTaskCount = taskRows.filter(task => task.execution_type === 'ignore').length;
  const unexecutedTaskCount = taskRows.filter(task => task.execution_type === null).length;

  return Promise.resolve({
    data: {
      total_task_count: totalTaskCount,
      accept_task_count: acceptTaskCount,
      ignore_task_count: ignoreTaskCount,
      unexecuted_task_count: unexecutedTaskCount,
      campaign_events: events,
    },
  });
}

export function getDemoPhysicianTasks(physicianId, userId, productId, isExecuted, pageNum, pageSize, roleId) {
  const rows = getFilteredTasks(productId, '', isExecuted, '', physicianId);
  return Promise.resolve({
    data: paginate(rows, pageNum, pageSize),
    data_count: rows.length,
  });
}

export function getDemoTaskStat(campaignEventId, productId) {
  const baseRows = getFilteredTasks(productId, campaignEventId, '', '', '');
  const users = ['华东一组', '华北二组', '华南一组', '西区团队'];
  const data = users.map((userName, index) => {
    const rows = baseRows.filter((task, taskIndex) => taskIndex % users.length === index);
    const taskNo = rows.length || 3 + index;
    const acceptNo = rows.filter(task => task.execution_type === 'accept').length + (index === 0 ? 1 : 0);
    const ignoreNo = rows.filter(task => task.execution_type === 'ignore').length;
    return {
      user_name_mr: userName,
      task_no: taskNo,
      accept_no: acceptNo,
      ignore_no: ignoreNo,
      execution_rate: taskNo ? Math.min((acceptNo + ignoreNo) / taskNo, 1) : 0,
    };
  });

  return Promise.resolve({ data });
}

export function executeDemoTask(executionType, campaignEventId, physicianId, userId, userName, territoryId, roleId) {
  taskRows = taskRows.map(task => {
    if (task.campaign_event_id === campaignEventId && task.physician_id === physicianId) {
      return {
        ...task,
        campaign_event_execution_id: task.campaign_event_execution_id || `demo-exec-${campaignEventId}-${physicianId}`,
        execution_type: executionType,
        execution_time: new Date().toISOString(),
      };
    }
    return task;
  });

  return Promise.resolve({
    campaign_event_execution_id: `demo-exec-${campaignEventId}-${physicianId}`,
    execution_type: executionType,
  });
}

export function getDemoSegmentTasks() {
  const value = campaignEvents
    .filter(event => event.event_type === 'segment')
    .map(event => ({
      campaign_event_name: event.campaign_event_name,
      event_type: event.event_type,
      campaign_event_id: event.campaign_event_id,
      start_date: event.event_start_date,
    }));

  return Promise.resolve({ value });
}
